export default "/images/vendor/flag-icon-css/flags/4x3/lr.svg?274e9865978ac60476fdab48cc2d2388";